import reducer from "./reducer";
export { default as PersonalData } from "./components/index";
export { default as personalDataReducerName } from "./constants";
export default reducer;
